<template>
  <div class="pagina-step">
    <div class="step-header">
      <span class="pagina-step-title">Identificação</span>
      <i class="icofont-trash" @click="openModalExcluir()"></i>
    </div>
    <div class="container-form">
      <ValidationObserver ref="observer" class="row c-gap">
        <div class="col-md-12 col-12">
          <validation-provider v-slot="{ errors }" rules="required|name">
            <div>
              <input
                name="nome"
                v-model="form.nome"
                class="form-control"
                placeholder="NOME COMPLETO"
                type="text"
                required
              />
            </div>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>

        <div class="col-md-12 col-12">
          <validation-provider v-slot="{ errors }" rules="required">
            <div>
              <vue-select
                v-model="form.perfil"
                :options="funcao"
                label="perfil"
                placeholder="PERFIL"
              >
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-12 col-12">
          <validation-provider
            v-slot="{ errors }"
            rules="required|email"
            ref="validationEmail"
          >
            <div>
              <input
                name="email"
                v-model="form.email"
                class="form-control"
                placeholder="E-MAIL"
                type="email"
              />
            </div>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-12 col-12">
          <validation-provider>
            <div>
              <the-mask
                :mask="['(##) ####-####', '(##) #####-####']"
                v-model="form.whatsapp"
                class="form-control"
                placeholder="WHATSAPP"
              />
            </div>
          </validation-provider>
        </div>
        <div class="col-md-12 col-12">
          <validation-provider
            v-slot="{ errors }"
            :rules="{ required: { allowFalse: false } }"
          >
            <div class="form-group input-group mb-0">
              <div class="checkbox-termos">
                <input
                  type="checkbox"
                  value=""
                  v-model="form.aceitarTermos"
                  required
                />
                Li e estou de acordo com os
                <span @click="showModalTermos = true">Termos de uso.</span>
              </div>
            </div>
            <div class="error">{{ errors[0] }}</div>

            <ModalTermos
              v-if="showModalTermos"
              @close-modal-termos="closeModalTermos()"
              @aceitar-termos="aceitarTermos()"
            >
            </ModalTermos>
          </validation-provider>
        </div>
      </ValidationObserver>
    </div>
    <div class="container-buttons">
      <button type="button" @click="voltar">Voltar</button>
      <button @click="proximo">
        Avançar
        <b-spinner
          label="Spinning"
          small
          variant="white"
          v-if="loading"
        ></b-spinner>
      </button>
    </div>

    <b-modal
      v-model="showModalExcluirUsuario"
      id="cofinanciamento-2024-modal-excluir-usuario"
      title=""
      centered
      scrollable
      hide-footer
    >
      <h3>Dados do Usuário</h3>
      <ul>
        <li>
          <strong>IBGE:</strong> <span>{{ user?.ibge }}</span>
        </li>
        <li>
          <strong>Cidade/UF:</strong> <span>{{ user?.cidade_uf }}</span>
        </li>
        <li>
          <strong>Email:</strong> <span>{{ user?.email }}</span>
        </li>
        <li>
          <strong>Nome do Contato:</strong>
          <span>{{ user?.nome_contato }}</span>
        </li>
        <li>
          <strong>Perfil:</strong> <span>{{ user?.perfil }}</span>
        </li>
        <li>
          <strong>Whatsapp:</strong> <span>{{ user?.whatsapp }}</span>
        </li>
        <!-- <li v-if="user?.dados != 'null'"><strong>Dados:</strong>
                <ul>
                    <li v-for="(value, key) in user?.dados" :key="key"><strong>{{ key }}:</strong> <span>{{ value }}</span></li>
                </ul>
            </li> -->
      </ul>
      <button @click="excluirUsuario()">
        Excluir
        <b-spinner
          label="Spinning"
          small
          variant="white"
          v-if="loadingBtnExcluir"
        ></b-spinner>
      </button>
    </b-modal>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { TheMask } from 'vue-the-mask'
import ModalTermos from '@/components/ModalTermos'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()
export default {
  components: {
    PulseLoader,
    'vue-select': VueSelect,
    ValidationObserver,
    ValidationProvider,
    TheMask,
    ModalTermos,
  },
  props: {
    dados: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        nome: '',
        perfil: '',
        email: '',
        whatsapp: '',
        aceitarTermos: false,
      },
      funcao: [
        { perfil: 'Secretário(a)' },
        { perfil: 'Coordenador(a)' },
        { perfil: 'Enfermeiro(a)' },
        { perfil: 'Administrador(A) e-SUS' },
        { perfil: 'Outro' },
      ],
      showModalTermos: false,
      showModalExcluirUsuario: false,
      loading: false,
      user: null,
      loadingBtnExcluir: false,
    }
  },
  mounted() {
    if (this.dados?.etapa2 !== null) {
      const etapa2 = this.dados?.etapa2
      this.form.nome = etapa2.nome
      this.form.perfil = etapa2.perfil
      this.form.email = etapa2.email
      this.form.whatsapp = etapa2.whatsapp
      this.form.aceitarTermos = etapa2.aceitarTermos
    }
  },
  methods: {
    aceitarTermos() {
      this.showModalTermos = false
      this.form.aceitarTermos = 'checked'
    },
    closeModalTermos() {
      this.showModalTermos = false
      this.form.aceitarTermos = ''
    },
    salvarDados() {
      this.$emit('dados-etapa', { etapa: 'etapa2', dados: this.form })
    },
    voltar() {
      this.$emit('etapa-anterior')
    },
    proximo() {
      this.$refs.observer.validate().then(async (success) => {
        if (success) {
          this.salvarDados()
          try {
            this.loading = true

            // limpa os objetos
            this.dados.etapa5 = null

            const user = await this.$apiPublic.get(
              `/cofinanciamento-federal-aps/usuario/${this.dados.etapa1.cidade.co_ibge}/${this.form.email}`
            )

            // A etapa 6 é preenchida sempre do endpoint do município
            const municipio = await this.$apiPublic.get(
              `/cofinanciamento-federal-aps/municipio/${this.dados.etapa1.cidade.co_ibge}`
            )
            if (municipio.data) {
              const ult_parc_previne = JSON.parse(
                municipio.data.ult_parc_previne
              )
              // etapa 6
              this.dados.etapa6 = {
                capitacaoPonderada: ult_parc_previne.capit_ponderada,
                indicadoresSaudeBucal: ult_parc_previne.desempenho_esb,
                indicadoresSaudeNaHora: ult_parc_previne.saude_na_h,
                informatizaAps: ult_parc_previne.informatiza_aps,
                pagamentoCriterioPopulacional: ult_parc_previne.per_capita,
                pagamentoDesempenho: ult_parc_previne.desempenho_esf_eap,
              }
            }

            if (user.data == false) {
              const response = await this.$apiPublic.post(
                '/cofinanciamento-federal-aps/usuario',
                {
                  ibge: this.dados.etapa1.cidade.co_ibge,
                  cidade_uf:
                    this.dados.etapa1.cidade.no_municipio +
                    ' - ' +
                    this.dados.etapa1.estado.uf,
                  email: this.form.email,
                  nome_contato: this.form.nome,
                  perfil: this.form.perfil.perfil,
                  whatsapp:
                    this.form.whatsapp != '' ? this.form.whatsapp : null,
                  dados: null,
                  sugestao_correcao: null,
                }
              )
              if (response.data.error == false) {
                this.$emit('proxima-etapa')
              }
            } else {
              const dados = JSON.parse(user.data.dados)
              // preencher os dados das próximas etapas
              if (dados != null) {
                // etapa 3
                this.dados.etapa3 = {
                  ied: {
                    label: dados.ied.label,
                    value: Number(dados.ied.value),
                  },
                  porte_populacional: dados.porte_populacional,
                }
                // etapa 4
                this.dados.etapa4 = {
                  ...dados.equipes_implantadas,
                }
                // etapa 5
                this.dados.etapa5 = {
                  equipesNovas: dados.equipes_novas.tem,
                  equipes: dados.equipes_novas.equipes,
                }

                // etapa 7
                if (dados.medicos_coparticipacao_mais_medicos != undefined) {
                  this.dados.etapa7 = {
                    medicos: dados.medicos_coparticipacao_mais_medicos,
                  }
                }

                // etapa 8
                if (dados.saude_bucal != undefined) {
                  this.dados.etapa8 = {
                    equipes: dados.saude_bucal,
                  }
                }

                // etapa 9
                if (dados.emulti != undefined) {
                  this.dados.etapa9 = {
                    equipes: dados.emulti,
                  }
                }

                // etapa 11
                if (dados.per_capita != undefined) {
                  this.dados.etapa11 = {
                    per_capita: dados.per_capita,
                  }
                }

                this.$emit('proxima-etapa')
              } else {
                this.$emit('proxima-etapa')
              }
            }
          } catch (error) {
            console.log(error)
          } finally {
            this.loading = false
          }
        } else {
          this.$toast.warning('Preencha os campos obrigatórios!', 'Erro:', {
            position: 'topRight',
          })
        }
      })
    },

    async openModalExcluir() {
      this.$refs.validationEmail.validate().then(async (success) => {
        if (success.valid) {
          const user = await this.$apiPublic.get(
            `/cofinanciamento-federal-aps/usuario/${this.dados.etapa1.cidade.co_ibge}/${this.form.email}`
          )
          if (user.data != false) {
            this.showModalExcluirUsuario = true
            this.user = user.data
          } else {
            this.$toast.error('Dados não encontrados', 'Error:', {
              position: 'topCenter',
            })
          }
        }
      })
    },

    async excluirUsuario() {
      try {
        this.loadingBtnExcluir = true
        const response = await this.$apiPublic.delete(
          '/cofinanciamento-federal-aps/usuario',
          {
            data: {
              ibge: this.user.ibge,
              email: this.user.email,
            },
          }
        )
        if (response.data.error == false) {
          this.$toast.success(response.data.message, 'Sucesso:', {
            position: 'topCenter',
          })
          this.showModalExcluirUsuario = false
        } else {
          this.$toast.error(response.data.message, 'Error:', {
            position: 'topCenter',
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingBtnExcluir = false
      }
    },
  },
}
</script>
<style scoped lang="scss" src="./styles.scss" />
<style scoped lang="scss">
.step-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  i {
    font-size: 28px;
    cursor: pointer;
    @media screen and (max-width: 656px) {
      font-size: 25px;
    }
  }
}
.checkbox-termos span {
  color: #00f;
  text-decoration: underline;
  cursor: pointer;
}
</style>
<style>
#cofinanciamento-2024-modal-excluir-usuario button {
  float: right;
  width: auto;
}
</style>
